import { useState } from "react";
import {
  useGetStudentsDataMutation,
  useExportStudentsDataMutation,
} from "./explorePageMutation";

const useExploreQueries = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [getStudentsData] = useGetStudentsDataMutation();
  const [exportStudentsData] = useExportStudentsDataMutation();

  const fetchStudentsData = async (page, limit, dateFilters) => {
    setLoading(true);
    setError(null);

    const payload = {
      event_date: dateFilters.event_date,
      registration_date: dateFilters.registration_date,
    };

    try {
      const response = await getStudentsData({
        page,
        limit,
        payload,
      }).unwrap();

      setLoading(false);
      return response;
    } catch (err) {
      setError(err.message || "Failed to fetch student data");
      setLoading(false);
      throw err;
    }
  };

  const exportData = async (dateFilters) => {
    setLoading(true);
    setError(null);

    const payload = {
      event_date: dateFilters.event_date,
      registration_date: dateFilters.registration_date,
    };

    try {
      const response = await exportStudentsData({ payload }).unwrap();
      setLoading(false);
      return { export_url: response };
    } catch (err) {
      setError(err.message || "Failed to export student data");
      setLoading(false);
      throw err;
    }
  };

  return {
    loading,
    error,
    fetchStudentsData,
    exportData,
  };
};

export default useExploreQueries;
